import React from 'react'
import PropTypes from 'prop-types'
import { ModalWrapper, ImageWithFallback } from 'components'
import { placeholderLogo } from 'images'
import { Close } from '@dsny/dsny-component-library/icons'

import fsStyles from './FullScreenModal.module.scss'

export default class FullScreenModal extends React.PureComponent {
  static propTypes = {
    content: PropTypes.string.isRequired,
    handleClose: PropTypes.func.isRequired,
    html: PropTypes.bool,
    imageStyle: PropTypes.object
  }
  static defaultProps = {
    html: false
  }
  render() {
    const { content, handleClose, html, imageStyle } = this.props
    return (
      <div
        className={`flex justify-end h-screen w-screen fixed left-0 top-0 z-20 py-16 bg-modalBackdrop ${fsStyles['bg-modal']}`}
      >
        <div className="flex flex-col justify-center h-full w-4/6 xl:w-1/3">
          <ModalWrapper
            className="overflow-y-auto"
            onClickOutside={handleClose}
          >
            {html ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: content
                }}
                className={`shadow-dark ${fsStyles['promo-bg']}`}
              />
            ) : (
              <ImageWithFallback
                className="w-full"
                src={content}
                fallback={placeholderLogo}
                alt="album cover"
                style={imageStyle}
              />
            )}
          </ModalWrapper>
        </div>
        <div className="w-1/6 xl:w-1/3 h-full">
          <button
            type="button"
            className="ml-12 focus:outline-none"
            onClick={handleClose}
          >
            <Close width={24} height={24} color="#FFFFFF" />
          </button>
        </div>
      </div>
    )
  }
}
